import React from 'react';
import { ChecklistGroup, ChecklistItem } from '../types/checklist';
import { ItemRow } from './ItemRow';

interface GroupProps {
  group: ChecklistGroup;
  index: number;
  isGroupCompleted: (group: ChecklistGroup) => boolean;
  getGroupProgress: (group: ChecklistGroup) => number;
  onToggle: (index: number) => void;
  onCheckItem: (groupIndex: number, itemIndex: number) => void;
  onInfo: (item: ChecklistItem, e: React.MouseEvent) => void;
}

export function Group({ group, index, isGroupCompleted, getGroupProgress, onToggle, onCheckItem, onInfo }: GroupProps) {
  return (
    <div className="mb-2 sm:mb-3 bg-navy-800 rounded-lg border border-navy-700 overflow-hidden">
      <button
        onClick={() => onToggle(index)}
        className="w-full px-2 sm:px-3 py-2 sm:py-2.5 flex items-center justify-between hover:bg-navy-700 transition-colors"
      >
        <div className="flex items-center gap-2">
          <div>
            <h3 className="text-xs sm:text-sm font-medium text-white">{group.title}</h3>
            <div className="text-xs text-gray-400 flex items-center gap-2">
              <span className={isGroupCompleted(group) ? 'text-green-400' : 'text-gray-400'}>
                {isGroupCompleted(group) ? 'Concluído' : 'Em progresso'}
              </span>
              <span className="text-gray-500">•</span>
              <span>{Math.round(getGroupProgress(group))}%</span>
            </div>
          </div>
        </div>
        <div className="text-xs text-gray-400 hidden sm:inline">{group.collapsed ? 'Expandir' : 'Recolher'}</div>
      </button>
      {!group.collapsed && (
        <div className="border-t border-navy-700">
          {group.items.map((item, itemIndex) => (
            <ItemRow
              key={item.id}
              item={item}
              onCheck={() => onCheckItem(index, itemIndex)}
              onInfo={(e) => onInfo(item, e)}
            />
          ))}
        </div>
      )}
    </div>
  );
}